(() => {
  const rootSelector = '[data-irriga-sticky-catalog]';

  const close = (root, returnFocus = false) => {
    if (!root?.classList.contains('is-open')) return;

    const button = root.querySelector('[data-irriga-sticky-catalog-button]');
    const panel = root.querySelector('[data-irriga-sticky-catalog-panel]');

    root.classList.remove('is-open');
    button?.setAttribute('aria-expanded', 'false');
    panel?.setAttribute('aria-hidden', 'true');

    if (returnFocus) button?.focus();
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('[data-irriga-sticky-catalog-button]');

    if (button) {
      const root = button.closest(rootSelector);
      const panel = root?.querySelector('[data-irriga-sticky-catalog-panel]');
      const shouldOpen = !root?.classList.contains('is-open');

      document.querySelectorAll(`${rootSelector}.is-open`).forEach((item) => {
        if (item !== root) close(item);
      });

      root?.classList.toggle('is-open', shouldOpen);
      button.setAttribute('aria-expanded', String(shouldOpen));
      panel?.setAttribute('aria-hidden', String(!shouldOpen));
      return;
    }

    document.querySelectorAll(`${rootSelector}.is-open`).forEach((root) => {
      if (!target || !root.contains(target)) close(root);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll(`${rootSelector}.is-open`).forEach((root) => {
      close(root, true);
    });
  });

  const header = document.querySelector('#header-component');

  if (header) {
    let scheduled = false;

    const updateScrollState = () => {
      scheduled = false;
      const hasScrolled = window.scrollY > 80;

      header.classList.toggle('irriga-has-scrolled', hasScrolled);

      if (!hasScrolled) {
        header.querySelectorAll(`${rootSelector}.is-open`).forEach((root) => close(root));
      }
    };

    const onScroll = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(updateScrollState);
    };

    updateScrollState();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
